module.exports = __webpack_public_path__ + "static/media/bonnevile-wp.2b32a27b.jpg";